import { Chip, type ChipProps } from '@mui/material'

interface FamilyColorBadgeProps extends Omit<ChipProps, 'label'> {
  /** Display text (user name or family name) */
  label: string
  /** Background color hex, e.g. '#1976d2'. When absent, renders a default outlined chip. */
  bgColor?: string
  /** Text color hex, e.g. '#000000'. When absent, defaults to black. */
  textColor?: string
}

/**
 * A Chip whose background is set to the family's assigned color.
 * Falls back to a default outlined chip when no color is provided
 * (e.g. the user has no family).
 */
export default function FamilyColorBadge({
  label,
  bgColor,
  textColor,
  sx,
  ...rest
}: FamilyColorBadgeProps) {
  if (!bgColor) {
    return <Chip label={label} size="small" variant="outlined" sx={sx} {...rest} />
  }

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        bgcolor: bgColor,
        color: textColor ?? '#000000',
        fontWeight: 600,
        // Theme-aware border keeps pastel chips visible on both light and dark backgrounds
        border: '1px solid',
        borderColor: 'rgba(0, 0, 0, 0.12)',
        ...sx,
      }}
      {...rest}
    />
  )
}
